/**
 * Centralized application routes
 */
export const ROUTES = {
  public: {
    home: "/",
    spaces: "/salas",
    castings: "/castings",
    castingsNew: "/castings/nuevo",
    calendar: "/calendario",
  },
  backoffice: {
    login: "/login",
    admin: "/admin",
    moderar: "/moderar",
    manager: "/gestion",
  },
} as const;

/**
 * Default redirect after login by role
 */
export const LOGIN_REDIRECT_BY_ROLE = {
  ADMIN: ROUTES.backoffice.admin,
  MODERATOR: ROUTES.backoffice.moderar,
  MANAGER: ROUTES.backoffice.manager,
} as const;

export const ADMIN_ROUTES = {
  castings: "castings",
  edit: ":id/editar",
  linkhub: "linkhub",
  new: "nuevo",
  rooms: "espacios-fisicos",
  root: "admin",
  tenants: "tenants",
  users: "usuarios",
} as const;

export const MODERATOR_ROUTES = {
  castings: "castings",
  edit: ":id/editar",
  new: "nuevo",
  root: "moderar",
} as const;

export const MANAGER_ROUTES = {
  calendar: "calendario",
  edit: ":id/editar",
  events: "eventos",
  linkGroupEdit: ":groupId/editar",
  linkGroups: "grupos",
  linkEdit: "links/:linkId/editar",
  linkhub: "linkhub",
  linkNew: "links/nuevo",
  new: "nuevo",
} as const;
